import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import React from 'react';
import { Icon } from '@cld/icon';
import { combineValues, globalTheme } from '@cld/component-theme';
import HandlerNormal from '../Handler';
import { sliderTheme } from '../../sliderTheme';

const trimSidesCss = css<{ direction: 'left' | 'right' }>`
  ${({ direction }) => `border-top-${direction}-radius:`} ${sliderTheme.trim.handler.border.radius};
  ${({ direction }) => `border-bottom-${direction}-radius:`} ${sliderTheme.trim.handler.border.radius};

  ${Icon} {
    position: relative;
    ${({ direction }) => `${direction}: -1px`};
  }
`;

const TrimHandler = styled(HandlerNormal).attrs(() => ({
  children: <Icon name="draggable" size="sm" />,
}))<{ direction: 'left' | 'right' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -2px;
  border: 2px solid ${globalTheme.palette.primary};
  width: ${sliderTheme.trim.handler.width};
  height: ${sliderTheme.trim.handler.height};
  color: ${combineValues(globalTheme.palette.primary, (color) => rgba(color, 0.5))};
  ${trimSidesCss}
`;

export default TrimHandler;
